import { API_ROOT } from '../constants/consts';

export function isAbsolutePath(path: string): boolean {
  return (
    typeof path === 'string' && (path.indexOf('http://') === 0 || path.indexOf('https://') === 0)
  );
}

export function getCorrectURL(path: string): string {
  return isAbsolutePath(path) ? path : `${API_ROOT}${path}`;
}
